export default __webpack_public_path__ + "static/B0143-61e4f5916049d923f129d589ecc36eba.png";